import React from 'react';
import { Link } from 'react-router-dom';

import ForgotPasswordForm from '../../auth/forgot-password/ForgotPasswordForm';
import AuthContainer from '../../auth/AuthContainer';

const ForgotPassword = () => (
  <AuthContainer>
    <p className="auth-page-title">Password reset</p>
    <ForgotPasswordForm />

    <div className="auth-page-footer">
      <Link to="/auth" className="auth-page-link">
        Back to login
      </Link>
    </div>
  </AuthContainer>
);

export default ForgotPassword;
